<style lang="less" scoped>
.list-container .list-content-div .list-header-title-div.title {
  line-height: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-button--default {
    width: 128px;
    height: 40px;
    border: 1px solid #bb87f3;
    border-radius: 5px;
    background-color: #fff;
    color: #bb87f3;
  }
  .el-button--primary {
    width: 128px;
    height: 40px;
  }
  .title-left {
    height: 72px;
    line-height: 72px;
    min-width: 300px;
    // background-color: red;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .title-right {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
    .logo {
      width: 45px;
      height: auto;
      opacity: 1;
      border-radius: 50%;
      margin-right: 10px;
    }
    p {
      width: 300px;
      font-size: 16px;
      font-weight: 400;
      color: #8f9bb3;
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-items: center;
    }
  }
}
.text {
  text-indent: 2em;
  margin: 20px auto;
  font-size: 14px;
}
.content {
  margin-top: 20px;
  max-width: 800px;
}
.content-text-url {
  p {
    font-size: 20px;
  }
  a {
    font-size: 20px;
    color: #bb87f3;
  }
}
</style>

<template>
  <div class="list-container">
    <phone
      ref="phone"
      :form="form"
      :showParentsSubmit="showParentsSubmit"
    ></phone>
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.preview"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div title">
        <!-- 头部 -->
        <div class="title-left">
          {{ form.activityTitle }}
        </div>

        <div class="title-right">
          <!-- <span style="margin-right:10px"><el-avatar src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar><span>挚达科技 2020-04-12 18:02:56</span></span> -->
          <p>
            <img class="logo" src="../../assets/phone/iavict.jpg" alt="" />
            <span>挚达科技{{ form.createdWhen }}</span>
          </p>
          <el-button class="btn" @click="handelBack">返 回</el-button>
          <el-button class="btn" type="primary" @click="handelPreview"
            >手机预览</el-button
          >
        </div>
      </div>
      <!-- 中心内容 -->
      <div class="content">
        <div
          v-if="!showUrlText"
          ref="content-box"
          v-html="form.activityText"
        ></div>
        <div class="content-text-url" v-else>
          <p>数据来源:{{ form.activitySource }}</p>
          <p>
            活动地址:
            <a href="" @click="handelUrl">{{ form.activitySourceUrl }}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
import phone from "@/components/phone-preview/index.vue";
export default {
  components: {
    phone,
  },
  data() {
    return {
      showParentsSubmit: false,
      showUrlText: false,
      pageConfig: pageConfig,
      fit: "contain",
      form: {},
    };
  },
  computed: {},
  watch: {},
  created() {
    if (this.$store.state.editId) {
      this.getFormInfo();
    }
  },
  methods: {
    //打开网页
    handelUrl() {
      let lg = this.form.activitySourceUrl.indexOf("http");
      if (lg < 0) {
        return window.open("http://" + this.form.activitySourceUrl);
      }
      window.open(this.form.activitySourceUrl);
    },
    // 获取信息详情
    getFormInfo() {
      let id = this.$store.state.editId;
      let _ = this;
      let url = _.$A.serviece.del;
      if (_.$route.query.activityStatus == "05") {
        url = _.$A.serviece.findInfo;
      }
      _.$H.get(_, url + id).then((res) => {
        if (res.data.data != null) {
          _.form = res.data.data;

          if (res.data.data.activitySourceUrl) {
            _.showUrlText = true;
          }
          const regex = new RegExp("<img", "gi");
          _.form.activityText = _.form.activityText.replace(
            regex,
            `<img style="max-width: 100%; height: auto"`
          );
        }
        // _.editor.txt.html(_.form.activityText);
      });
    },
    // 返回上一页并附带活动状态
    handelBack() {
      let obj = {};
      obj.activityStatus = this.$route.query.activityStatus;
      this.$router.push({
        name: "activityManagement",
        params: obj,
      });
    },
    // 手机游览
    handelPreview() {
      this.$refs.phone.goShow();
    },
  },
  mounted() {},
};
</script>
